import { _ as r } from "../internals/export.js";
import { i as o } from "../internals/is-array.js";
import { i as s } from "../internals/is-constructor.js";
import { i as t } from "../internals/is-object.js";
import { t as i } from "../internals/to-absolute-index.js";
import { l as a } from "../internals/length-of-array-like.js";
import { t as e } from "../internals/to-indexed-object.js";
import { c as n } from "../internals/create-property.js";
import { w as m } from "../internals/well-known-symbol.js";
import { a as l } from "../internals/array-method-has-species-support.js";
import { a as p } from "../internals/array-slice.js";
var f = l("slice"),
  c = m("species"),
  j = Array,
  d = Math.max;
r({
  target: "Array",
  proto: !0,
  forced: !f
}, {
  slice: function slice(r, m) {
    var l,
      f,
      y,
      u = e(this),
      v = a(u),
      h = i(r, v),
      b = i(void 0 === m ? v : m, v);
    if (o(u) && (s(l = u.constructor) && (l === j || o(l.prototype)) ? l = void 0 : t(l) && null === (l = l[c]) && (l = void 0), l === j || void 0 === l)) return p(u, h, b);
    for (y = 0, f = new (void 0 === l ? j : l)(d(b - h, 0)); h < b; h++, y++) h in u && n(f, y, u[h]);
    return f.length = y, f;
  }
});